import React from 'react'

import './model-image.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import fallbackSource from '../../../../commons/src/assets/images/model-thumbnail-fallback.svg'

import ImageContainer from '../../../../commons/src/components/image-container/image-container'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    source?: string
    size?: 'default' | 's' | 'm' // default inherits size
    alt: string
    onClick?: React.MouseEventHandler
  }
>

const ModelImage = ({className, source, size = 'default', alt, onClick, ...props}: Props) => (
  <div
    {...props}
    className={cn('ModelImage', {[`size-${size}`]: !!size, clickable: !!onClick}, className)}
    onClick={onClick}
  >
    <ImageContainer ratio="1-1" source={source} fallbackSource={fallbackSource} alt={alt} />
  </div>
)

export default ModelImage
